import React from 'react'
import { Divider } from '@mui/material'

import ClientHeader from '../../../components/ClientHeader/ClientHeader'
import DetailsSummarySection from '../../../components/details/summary/DetailsSummarySection'
import PaymentAttachmentsCard from '../../../components/details/attachments/PaymentAttachmentsCard'
import ProgressSummaryCard from '../../../components/details/progress/ProgressSummaryCard'
import { REFUND_HEADER_CONFIG } from '../../show/shared/refundConstants'
import { REFUND_APPROVAL_TEXT } from '../../constants/refundApprovalText'
import { REFUND_APPROVAL_HISTORY_TAB } from '../../helpers/refundApprovalUtils'
import { UI_TEXT_ATTACHMENTS } from '../../../constants/uiText'
import { UI_COLOR_BORDER_DIVIDER } from '../../../constants/uiColors'
import RefundChronologicalHistoryTab from '../RefundChronologicalHistoryTab'
import RefundApprovalTabsHeader from '../components/approval/RefundApprovalTabsHeader'
import RefundApprovalDetailActions from '../components/approval/RefundApprovalDetailActions'
import RefundApprovalProductsSection from '../components/approval/RefundApprovalProductsSection'
import RefundNcrGuidanceNote from '../components/ncr/RefundNcrGuidanceNote'

const normalizeDesktopDetailFields = (fields = []) =>
  fields.map((field) => ({ ...field, fullWidth: false }))

const RefundApprovalDetailDesktop = ({
  activity,
  activeTab,
  setActiveTab,
  detailTabs,
  canViewHistory,
  statusOption,
  headerData,
  summaryFields,
  fieldsToRender,
  paymentAttachments,
  progressPercent,
  progressSummaryMetrics,
  processingLines,
  processedLinesCount,
  allLinesRejected,
  canApproveCount,
  canWrite,
  canRegisterNcr,
  isFinalized,
  showLineActions,
  loading,
  isGeneratingPdf,
  copyTooltip,
  openScanModal,
  setLineToReject,
  handleCopyTable,
  handleDownloadTableCsv,
  handleDownloadTablePdf,
  openRejectConfirm,
  openApproveConfirm,
  openNcrDialog
}) => {
  const desktopSummaryFields = normalizeDesktopDetailFields(summaryFields)
  const desktopExtraFields = normalizeDesktopDetailFields(fieldsToRender)

  return (
    <>
      <RefundApprovalTabsHeader
        tabs={detailTabs}
        activeTab={activeTab}
        onChange={setActiveTab}
        statusOption={statusOption}
        activity={activity}
      />

      {activeTab === REFUND_APPROVAL_HISTORY_TAB && canViewHistory ? (
        <RefundChronologicalHistoryTab
          refundUuid={activity?.uuid}
          rejectionReason={activity?.global_motive}
        />
      ) : (
        <>
          <RefundApprovalDetailActions
            canWrite={canWrite}
            canRegisterNcr={canRegisterNcr}
            isFinalized={isFinalized}
            loading={loading}
            canApproveCount={canApproveCount}
            showLineActions={showLineActions}
            allLinesRejected={allLinesRejected}
            processedLinesCount={processedLinesCount}
            processingLinesCount={processingLines.length}
            isGeneratingPdf={isGeneratingPdf}
            onRejectClick={openRejectConfirm}
            onApproveClick={openApproveConfirm}
            onNcrClick={openNcrDialog}
            onExportCsv={handleDownloadTableCsv}
            onExportPdf={handleDownloadTablePdf}
          />

          {canRegisterNcr && <RefundNcrGuidanceNote />}

          <ClientHeader data={headerData} config={REFUND_HEADER_CONFIG} />

          <ProgressSummaryCard
            title={REFUND_APPROVAL_TEXT.summaryTitle}
            progressLabel={REFUND_APPROVAL_TEXT.progressLabel}
            progressPercent={progressPercent}
            metrics={progressSummaryMetrics}
          />

          <DetailsSummarySection
            summaryFields={desktopSummaryFields}
            extraFields={desktopExtraFields}
            summaryTitle={REFUND_APPROVAL_TEXT.detailsTitle}
            summaryOpenLabel={REFUND_APPROVAL_TEXT.openDetails}
            summaryCloseLabel={REFUND_APPROVAL_TEXT.closeDetails}
            summaryColumns={3}
          />

          <PaymentAttachmentsCard
            images={paymentAttachments.images}
            files={paymentAttachments.files}
            title={UI_TEXT_ATTACHMENTS}
            emptyDescription={REFUND_APPROVAL_TEXT.attachmentsEmpty}
          />

          <Divider
            sx={{
              flexBasis: '100%',
              width: '100%',
              border: 0,
              borderTop: `1px solid ${UI_COLOR_BORDER_DIVIDER}`,
              mt: 3,
              mb: 2
            }}
          />

          <RefundApprovalProductsSection
            showLineActions={showLineActions}
            isFinalized={isFinalized}
            loading={loading}
            lines={processingLines}
            copyTooltip={copyTooltip}
            onCopyTable={handleCopyTable}
            onDownloadCsv={handleDownloadTableCsv}
            onScan={openScanModal}
            onEditLine={openScanModal}
            onRejectLine={setLineToReject}
          />
        </>
      )}
    </>
  )
}

export default RefundApprovalDetailDesktop
